import { fetchCurrentStudentAssignmentsIfNotFetched } from "seneca-common/features/assignments/features/student-assignments/service";
import { fetchLocationsIfNotFetched } from "seneca-common/features/locations/service";
import { fetchMemoriesIfNotFetched } from "seneca-common/features/memories/service";
import {
  fetchAllStatsForCourseIfNotFetched,
  fetchUserStudyStatsIfNotFetched
} from "seneca-common/features/stats/service";
import { fetchSubscriptionsIfNotFetched } from "seneca-common/features/subscriptions/state/service";
import logError from "seneca-common/utils/sentry/logError";

export default function fetchAllClassroomData(
  courseId: string,
  assignmentsDueDateFrom: string
) {
  return async (dispatch: any) => {
    try {
      const promises: Promise<any>[] = [];

      // TODO: fetch course sections in here, it's not super nice that some data is fetched here and some in HOC's somewhere else
      promises.push(dispatch(fetchLocationsIfNotFetched()));
      promises.push(dispatch(fetchMemoriesIfNotFetched()));
      promises.push(
        dispatch(
          fetchCurrentStudentAssignmentsIfNotFetched({
            date: assignmentsDueDateFrom,
            archived: false
          })
        )
      );
      dispatch(fetchUserStudyStatsIfNotFetched());

      promises.push(dispatch(fetchSubscriptionsIfNotFetched()));
      promises.push(dispatch(fetchAllStatsForCourseIfNotFetched(courseId)));

      await Promise.all(promises);
    } catch (error: any) {
      logError(error, {
        extraInfo: "Error fetching data for the classroom"
      } as any);
      throw error;
    }
  };
}
